export default "__VITE_ASSET__DNCMBE2j__"